import React from 'react';

import { useClassnames } from '@lumapps/classnames';
import { useFocused, useSelected, ReactEditor, type Path, useSlateStatic } from '@lumapps/wrex/slate';
import type { ElementRender, WrexEditor } from '@lumapps/wrex/types';

import { COLUMN } from '../../../constants';
import type { ColumnElement, ColumnsEditor } from '../../../types';
import { isColumnEmpty } from '../../../utils/isColumnEmpty';
import { Column } from '../../blocks/Column';
import { Placeholder } from '../Placeholder';

import './index.scss';

const CLASSNAME = 'wrex-content-column';

/**
 * Display a column to add content
 */
export const EditableColumn: ElementRender<ColumnElement, HTMLDivElement> = (props) => {
    const { block } = useClassnames(CLASSNAME);
    const { children, element, ...forwardedProps } = props;
    const isFocused = useFocused();
    const isSelected = useSelected();
    const selected = isSelected && isFocused;
    const editorStatic = useSlateStatic() as WrexEditor<ColumnsEditor>;
    const columnElement = element as ColumnElement;
    const columnPath = ReactEditor.findPath(editorStatic, columnElement) as Path;

    const isEmpty = React.useMemo(() => isColumnEmpty(editorStatic, columnPath), [editorStatic, columnPath]);

    return (
        <Column {...forwardedProps} element={columnElement} className={block({ editable: true, selected })}>
            {children}
            {!selected && isEmpty && <Placeholder />}
        </Column>
    );
};
EditableColumn.displayName = COLUMN;
